import React from 'react';
import '../styles/PrivacyPolicy.css';
import { useI18n } from '../../i18n/I18nProvider';

const PrivacyPolicy = () => {
  const { t, language } = useI18n();
  
  const formatDate = (date) => {
    return date.toLocaleDateString(language === 'es' ? 'es-ES' : 'en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };
  
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1 className="privacy-title">{t('privacy.title')}</h1>
        
        <div className="privacy-intro">
          <p>{t('privacy.intro')}</p>
        </div>

        <div className="privacy-section">
          <h2 className="privacy-subtitle">{t('privacy.informationWeCollect.title')}</h2>
          <p>{t('privacy.informationWeCollect.content')}</p>
          <ul className="privacy-list">
            {t('privacy.informationWeCollect.items').map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="privacy-section">
          <h2 className="privacy-subtitle">{t('privacy.howWeUse.title')}</h2>
          <p>{t('privacy.howWeUse.content')}</p>
          <ul className="privacy-list">
            {t('privacy.howWeUse.items').map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="privacy-section">
          <h2 className="privacy-subtitle">{t('privacy.cookies.title')}</h2>
          <p>{t('privacy.cookies.content')}</p>
          <p>{t('privacy.cookies.subtitle')}</p>
          <ul className="privacy-list">
            {t('privacy.cookies.items').map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="privacy-section">
          <h2 className="privacy-subtitle">{t('privacy.dataSharing.title')}</h2>
          <p>{t('privacy.dataSharing.content')}</p>
          <ul className="privacy-list">
            {t('privacy.dataSharing.items').map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="privacy-section">
          <h2 className="privacy-subtitle">{t('privacy.dataSecurity.title')}</h2>
          <p>{t('privacy.dataSecurity.content')}</p>
        </div>

        <div className="privacy-section">
          <h2 className="privacy-subtitle">{t('privacy.yourRights.title')}</h2>
          <p>{t('privacy.yourRights.content')}</p>
          <ul className="privacy-list">
            {t('privacy.yourRights.items').map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="privacy-section">
          <h2 className="privacy-subtitle">{t('privacy.thirdPartyLinks.title')}</h2>
          <p>{t('privacy.thirdPartyLinks.content')}</p>
        </div>

        <div className="privacy-section">
          <h2 className="privacy-subtitle">{t('privacy.childrensPrivacy.title')}</h2>
          <p>{t('privacy.childrensPrivacy.content')}</p>
        </div>

        <div className="privacy-section">
          <h2 className="privacy-subtitle">{t('privacy.internationalDataTransfers.title')}</h2>
          <p>{t('privacy.internationalDataTransfers.content')}</p>
        </div>

        <div className="privacy-section">
          <h2 className="privacy-subtitle">{t('privacy.changesToPolicy.title')}</h2>
          <p>{t('privacy.changesToPolicy.content')}</p>
        </div>

        <div className="privacy-section">
          <h2 className="privacy-subtitle">{t('privacy.contactUs.title')}</h2>
          <p>{t('privacy.contactUs.content')}</p>
          <p>
            <strong>{t('privacy.contactUs.lastUpdated')}</strong> {formatDate(new Date())}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
